<template>
  <div>
    <a-card
      :headStyle="{
        background: '#f8f8f8',
        border: 'none'
      }"
      @tabChange="cardtabChange"
      :tabList="panes"
      :bodyStyle="{
        padding: '0'
      }"
      style="box-shadow: none"
    >
      <div class="chooseDate">
        <div class="money">
          <span class="name">余额：</span>
          {{ "¥" + balanceAmount }}
          <a-button type="primary" class="submitBtn" @click="handleRecharge">
            充值
          </a-button>
        </div>
        <a-form layout="inline">
          <a-form-item>
            <a-range-picker
              v-model:value="searchForm.orderdate"
              :placeholder="['账单开始', '账单结束']"
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
            />
          </a-form-item>
          <a-form-item>
            <a-select
              v-model:value="searchForm.paymentType"
              placeholder="支付平台"
              style="width: 200px"
              allowClear
              class="rechargeDetail"
            >
              <a-select-option v-for="d in paymentTypeData" :key="d.value" :value="d.value" :label="d.label">
                {{ d.label }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="searchAction">
              查询
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="false"
        :row-key="(r) => r.id"
        :loading="loading"
      >
        <template v-slot:operation="{ text, record }">
          <a-button
            type="danger"
            @click="handleCancel(record)"
            size="small"
            class="handleBtn"
            :loading="loadingCancel"
            v-show="record.payState == 10 && record.state != 90"
          >
            取消
          </a-button>
          <a-button
            type="primary"
            @click="handlePay(record)"
            size="small"
            class="handleBtn"
            :loading="loadingPay"
            v-show="record.payState == 10 && record.state != 90"
          >
            支付
          </a-button>
        </template>
      </a-table>
    </a-card>

    <df-pagination :model="pageObj"></df-pagination>
  </div>
</template>

<script>
import { ref, reactive, provide, createVNode } from "vue";
import myApi from "@axios/my";
import { Modal, destroyAll, notification, message } from "ant-design-vue";
import { useRoute, useRouter } from "vue-router";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { exportOut } from "@axios/exportOut";
export default {
  name: "rechargeDetail",
  components: {
    ExclamationCircleOutlined
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    let activeKey = ref("10");
    let searchForm = reactive({
      paymentType: "",
      orderdate: []
    });

    let searchParams = reactive({
      paymentType: ""
    });

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1
    });

    let balanceAmount = ref("");

    const searchAction = () => {
      searchParams.paymentType = searchForm.paymentType;
      if (searchForm.orderdate) {
        searchParams.tktsStartTime = searchForm.orderdate[0];
        searchParams.tktsEndTime = searchForm.orderdate[1];
      } else {
        searchParams.tktsStartTime = "";
        searchParams.tktsEndTime = "";
      }

      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1
      };
      getList();
    };

    let list = ref([]);

    let loading = ref(false);

    const getList = () => {
      let params = {
        business: activeKey.value,
        paymentType: searchParams.paymentType ? searchParams.paymentType : null,
        beginTime: searchParams.tktsStartTime ? searchParams.tktsStartTime : null,
        endTime: searchParams.tktsEndTime ? searchParams.tktsEndTime : null,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows
      };

      loading.value = true;

      myApi.getrechargeDetail(params).then((res) => {
        console.log(res);
        loading.value = false;
        if (!res.dataList) return;
        pageObj.value.totle = res.dataList.total;
        pageObj.value.page = res.dataList.page;
        list.value = res.dataList.data;
        balanceAmount.value = res.balanceAmount;
      });
    };

    getList();

    const reset = () => {
      searchForm.supplierId = "";
      searchForm.orderdate = [];

      searchAction();
    };

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    const handleDelete = (item) => {
      console.log(item);
    };

    let panes = ref([
      { tab: "火车票", key: "10" },
      { tab: "酒店", key: "20" },
      { tab: "国际机票", key: "30" },
      { tab: "国内机票", key: "40" },
      { tab: "打车", key: "50" }
    ]);

    const cardtabChange = (key) => {
      activeKey.value = key;
      reset();
    };

    // 取消支付
    let loadingCancel = ref(false);
    const handleCancel = (item) => {
      Modal.confirm({
        title: "是否确认取消支付？",
        icon: createVNode(ExclamationCircleOutlined),
        content: "",
        onOk() {
          loadingCancel.value = true;
          myApi.cancelRecharge(item.id).then((res) => {
            loadingCancel.value = false;
            message.success("已取消");
            getList();
          });
        },
        onCancel() {}
      });
    };

    // 支付
    let loadingPay = ref(false);
    const handlePay = (item) => {
      let params = {
        rechargeNo: item.rechargeNo,
        appPlatform: 10,
        returnUrl: window.location.origin + "/rechargeDetail"
      };
      Modal.confirm({
        title: "是否确认支付？",
        icon: createVNode(ExclamationCircleOutlined),
        content: "",
        onOk() {
          loadingPay.value = true;
          myApi.payRecharge(params).then((res) => {
            loadingPay.value = false;
            window.location.href = res.cashierUrl + "?advanceOrderNo=" + res.advanceOrderNo + "&type=train";
          });
        },
        onCancel() {}
      });
    };

    // 充值
    const handleRecharge = () => {
      router.push({
        name: "createRecharge",
        query: {
          business: activeKey.value,
          type: 1
        }
      });
    };

    return {
      activeKey,
      cardtabChange,
      panes,
      handleDelete,
      loading,
      list,
      pageObj,
      searchForm,
      searchAction,
      reset,
      balanceAmount,
      columns: [
        {
          title: "支付方式",
          dataIndex: "paymentTypeValue",
          // width: 60,
          align: "center"
        },
        {
          title: "流水号",
          dataIndex: "paymentCode",
          // width: 100,
          align: "center"
        },
        {
          title: "支付单号",
          dataIndex: "rechargeNo",
          // width: 100,
          align: "center"
        },
        {
          title: "充值金额",
          dataIndex: "amount",
          // width: 60,
          align: "center"
        },
        {
          title: "充值/完成时间",
          dataIndex: "payTime",
          // width: 80,
          align: "center"
        },
        {
          title: "充值状态",
          dataIndex: "stateValue",
          // width: 40,
          align: "center"
        },
        {
          title: "操作",
          dataIndex: "operation",
          // width: 200,
          align: "center",
          slots: { customRender: "operation" }
        }
      ],
      paymentTypeData: [
        {
          label: "支付宝",
          value: "10"
        },
        {
          label: "微信",
          value: "20"
        },
        {
          label: "银行汇款",
          value: "30"
        }
      ],
      handleRecharge,
      loadingCancel,
      handleCancel,
      handlePay,
      loadingPay
    };
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table_logo {
  width: 70px;
}
.chooseDate {
  // background: #f8f8f8;
  padding: 15px 0 10px 22px;
  text-align: left;
  .money {
    margin-bottom: 10px;
    .name {
      font-weight: 700;
    }
    .submitBtn {
      background: #ffab00;
      border-color: #ffab00;
      margin-left: 17px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      border-radius: 4px;
    }
  }
}
.handleBtn {
  display: block;
  width: 60px;
  margin: 4px auto;
  font-size: 12px;
}
</style>
